/**
 * SessionStatusService
 * Service for managing session statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for session status CRUD operations
 */
export class SessionStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SessionStatusService.DEFAULT_SERVICE_PATH,
            basePath: SessionStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
SessionStatusService.DEFAULT_SERVICE_PATH = 'ac-courses';
SessionStatusService.BASE_PATH = 'api/session-statuses';
//# sourceMappingURL=SessionStatusService.js.map